import { render, staticRenderFns } from "./NWBreadcrumbButton.component.vue?vue&type=template&id=5f2ff8cb&scoped=true&"
import script from "./NWBreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./NWBreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./NWBreadcrumbButton.component.vue?vue&type=style&index=0&id=5f2ff8cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2ff8cb",
  null
  
)

export default component.exports